import React from "react";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

import { useI18n } from "../../I18nProvider";

export default function FormTable(props) {
  const appText = useI18n();
  return (
    <Grid item={true} xs={12}>
      <Paper>
        <Table>
          <TableHead>
            {props.type === "publishing" ? (
              <TableRow>
                <TableCell>{appText.T306}</TableCell>
                <TableCell>{appText.T80}</TableCell>
                <TableCell>{appText.T324}</TableCell>
                <TableCell>{appText.T310}</TableCell>
                <TableCell>{appText.T326}</TableCell>
                <TableCell>{appText.T316}</TableCell>
                <TableCell></TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell>{appText.T106}</TableCell>
                <TableCell>{appText.T80}</TableCell>
                <TableCell>{appText.T81}</TableCell>
                <TableCell>{appText.T82}</TableCell>
                <TableCell>{appText.T110}</TableCell>
                <TableCell>{appText.T111}</TableCell>
                <TableCell></TableCell>
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {props.modalSubmitData.map((row, index) => (
              <TableRow key={index}>
                <TableCell> {row.licenseeRef}</TableCell>
                <TableCell>{row.retailerSKU}</TableCell>
                <TableCell>
                  {props.type === "publishing" ? row.isbn10 : row.UPC}
                </TableCell>
                <TableCell>{row.productDetail}</TableCell>
                <TableCell>
                  <ul>
                    {Array.isArray(row.assetFileName)
                      ? row.assetFileName.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))
                      : ""}
                  </ul>
                </TableCell>
                <TableCell>{row.onShelfDate}</TableCell>
                <TableCell>
                  <Button onClick={() => props.editRow(index)}>
                    <EditIcon />
                  </Button>
                  <Button onClick={() => props.deleteRow(index)}>
                    <DeleteIcon />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Grid>
  );
}
